import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { FormSelect, Fieldset, FormNumber, FormRadio, TextArea } from '~/components/FormControl';

function DescriptionAndClassBonus({ bonusConditions }) {
    return (
        <Fieldset fieldsetStyle={{ flexBasis: '100%' }}>
            <Fieldset.Legend>Description & Class Bonus</Fieldset.Legend>
            <Row>
                <TextArea
                    name="description"
                    rows={2}
                />
                <FormNumber name="classBonus.attackModifiedValue" />
                <FormNumber name="classBonus.defenseModifiedValue" />
                <FormNumber name="classBonus.healedValue" />
                <FormSelect
                    name="classBonus.bonusConditionOption"
                    options={bonusConditions}
                />
                <FormRadio
                    name="classBonus.applyOnce"
                    sm={1}
                />
            </Row>
        </Fieldset>
    );
}

DescriptionAndClassBonus.propTypes = {
    bonusConditions: PropTypes.array.isRequired,
};
export default DescriptionAndClassBonus;
